<div class="rounded">
	<div
		class="w-full h-full flex flex-col justify-center items-center px-8 py-8"
	>
		<img
			class="credit-card-image"
			src="/assets/images/file-creation/add-credit-card.svg"
		/>
		<h4 class="tracking-wide mt-4">
			{{
				fileType
					? 'Add billing details to continue.'
					: 'Your trial of Closer has ended.'
			}}
		</h4>
		<div
			class="text-sm text-center"
			*ngIf="isLoggedInUserAdmin$ | async; else notAdmin"
		>
			<p>
				To continue{{ fileType ? ' to add more ' + fileType + ' files' : '' }},
				simply add your billing details. There's no commitment; you can cancel
				any time!
			</p>
		</div>
		<ng-template #notAdmin>
			<div class="text-sm text-center">
				<p>
					To continue{{
						fileType ? ' to add more ' + fileType + ' files' : ''
					}}, contact one of the following admins to add billing details to your
					account
				</p>
			</div>
			<div class="flex flex-row gap-1 my-4">
				<app-business-user
					*ngFor="let admin of admins$ | async"
					[showName]="true"
					[userId]="admin.id"
					size="xsmall"
				></app-business-user>
			</div>
		</ng-template>
		<div
			class="flex flex-row mt-8 w-full"
			[ngClass]="
				(isLoggedInUserAdmin$ | async)
					? 'justify-center gap-5'
					: 'justify-start'
			"
		>
			<app-button
				btn="tertiary"
				size="small"
				(onClick)="close()"
				[testHook]="testHooks.Button"
			>
				{{ fileType ? 'Go back' : 'Remind me later' }}
			</app-button>
			<ng-container *ngIf="isLoggedInUserAdmin$ | async">
				<app-button
					class="contact-sales-bot"
					attr.data-intercom-target="contact-sales-intercom-trigger"
					btn="border"
					size="small"
					[testHook]="testHooks.ContactSalesButton"
					>Contact sales</app-button
				>
				<app-button
					size="small"
					(onClick)="goToBilling()"
					[testHook]="testHooks.ContinueToBillingButton"
					>Continue to billing</app-button
				>
			</ng-container>
		</div>
	</div>
</div>
